export default {
    INDIVIDUAL:'Individual',
    COMPANY:'Company',
    INDIVIDUAL_OR_COMPANY:'Are they an individual or company?',
}